

jQuery("[id*=area_needed]").val("");
jQuery(".product_price_overage_new").text("");
jQuery(".qty").val(1);

if (document.querySelector('[id*=sample_quantity]')) {
  document.querySelector('[id*=sample_quantity]').value = 1;
}

$(document).on("change keyup", ".template-product [id*=ft_need]", function () {
  myFunction2($(this).val());
});
$(document).on("change keyup", ".template-product [id*=finalquantity]", function () {
  myFunctionInput2($(this).val());
  $(this).val()
});

function myFunctionInput2(val) {
  if (val) {
    let v_id = $('[name="id"]').val();
    let variant = meta.product.variants.find(function (item) {
      return item.id == v_id;
    });

    document.querySelector('[id*=finalquantity]').value = val;
    document.querySelector('.product__quantity input[name="quantity"]').value =
      val;
    let price = variant.price;
    var total_price = parseFloat(price * val);
    var tot_price = theme.Currency.formatMoney(
      total_price,
      theme.settings.moneyFormat
    );
    document.querySelector('[id*=total_price_2]').innerHTML =
      '<span class="amount">' + tot_price + "</span>";
  }
}

function myFunction2(val) {
  if (val) {
    var actual_area = document.querySelector('[id*=area_actual]').innerHTML;
    var overage_sq_ft = parseFloat(val);
    var total_sq_ft_needed = overage_sq_ft.toFixed(2) * 1;
    // document.getElementById("pp_overage_new").innerHTML = total_sq_ft_needed * 1;
    var SQ_FT_per_box1 = document.querySelector('[id*=area_actual]').innerHTML * 1;
    var SQ_FT_per_box = SQ_FT_per_box1.toFixed(2) * 1;
    var tot_num_boxes = (total_sq_ft_needed / SQ_FT_per_box).toFixed(2) * 1;
    if (tot_num_boxes) {
      document.querySelector('[id*=pp_overage_new_1]').innerHTML = tot_num_boxes;
      var tot_num_boxes = Math.ceil(tot_num_boxes);
      document.querySelector('[id*=finalquantity]').value = tot_num_boxes;
      document.querySelector(
        '.product__quantity input[name="quantity"]'
      ).value = tot_num_boxes;
      let v_id = $('[name="id"]').val();
      console.log('meta', meta.product.variants)
      let variant = meta.product.variants.find(function (item) {
        return item.id == v_id;
      });
      let price = variant.price;
      var total_price = parseFloat(price * tot_num_boxes);
      var tot_price = theme.Currency.formatMoney(
        total_price,
        theme.settings.moneyFormat
      );
       document.querySelector('[id*=total_price_2]').innerHTML =
        '<span class="amount">' + tot_price + "</span>";
    }
  }
}
$(document).on("change keyup", ".modal__inner [id*=ft_need-modal]", function (e) {
  e.preventDefault();
  // console.log($(this).val(),'================');
  var _this = $(this);
  var _parent = $(this).parents('.modal__centered-content')
  var currentValue = $(this).val();
    if (currentValue) {
    var actual_area = _parent.find('[id*=area_actual-modal]').text();
    var overage_sq_ft = parseFloat(currentValue);
    var total_sq_ft_needed = overage_sq_ft.toFixed(2) * 1;
    var SQ_FT_per_box1 = parseFloat(actual_area) * 1;
    var SQ_FT_per_box = SQ_FT_per_box1.toFixed(2) * 1;
    var tot_num_boxes = (total_sq_ft_needed / SQ_FT_per_box).toFixed(2) * 1;
    if (tot_num_boxes) {
      _parent.find('[id*=pp_overage_new_1-modal]').text(tot_num_boxes);
      var tot_num_boxes = Math.ceil(tot_num_boxes);
      _parent.find('[id*=finalquantity-modal]').val(tot_num_boxes);
       _parent.find('.js-qty__wrapper input[name="quantity"]').val(tot_num_boxes);
      let v_id = _parent.find('[name="id"]').val();
      let pId = _parent.find('.product-section').attr('data-product-id')
      let idselector = 'wcp_json_'+ pId +'-modal';
      let productDetailss = JSON.parse(_parent.find('#wcp_json_'+ pId +'-modal').text());
      console.log('meta', productDetailss)
      let variant = productDetailss.variants.find(function (item) {
        return item.id == v_id;
      });
      let price = variant.price;
      var total_price = parseFloat(price * tot_num_boxes);
      var tot_price = theme.Currency.formatMoney(
        total_price,
        theme.settings.moneyFormat
      );
      _parent.find('[id*=total_price_2-modal]').html('<span class="amount">' + tot_price + '</span>');
    }
  }
});